import styled from '@emotion/styled';
import { Checkbox } from 'antd';

import { colorConstants } from 'config/colorConstants';

export const CustomCheckbox = styled(Checkbox)`
    .ant-checkbox-inner {
        border: 1px solid ${colorConstants.borderGrey};
        border-radius: 4px;
    }

    &:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner {
        border-color: ${colorConstants.borderGrey} !important;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        background: ${colorConstants.violet};
        border-color: ${colorConstants.violet};
    }

    &:hover .ant-checkbox-checked .ant-checkbox-inner,
    .ant-checkbox-checked:hover .ant-checkbox-inner {
        background: ${colorConstants.violet};
        border-color: ${colorConstants.violet} !important;
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
        border-color: ${colorConstants.white};
    }

    /* Remove Ant Design click/focus blue outline ring */
    .ant-checkbox::after,
    .ant-checkbox-checked::after {
        display: none !important;
        border: none !important;
        animation: none !important;
    }

    .ant-checkbox-input:focus + .ant-checkbox-inner,
    .ant-checkbox-input:focus-visible + .ant-checkbox-inner {
        border-color: ${colorConstants.borderGrey} !important;
        box-shadow: none !important;
        outline: none !important;
    }

    .ant-checkbox-checked .ant-checkbox-input:focus + .ant-checkbox-inner,
    .ant-checkbox-checked .ant-checkbox-input:focus-visible + .ant-checkbox-inner {
        border-color: ${colorConstants.violet} !important;
        box-shadow: none !important;
    }

    &.ant-checkbox-wrapper-disabled .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
        background: ${colorConstants.violet} !important;
        border-color: ${colorConstants.violet} !important;
        opacity: 1;
    }

    &.ant-checkbox-wrapper-disabled .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
        border-color: ${colorConstants.white} !important;
        opacity: 1;
    }
`;
